import { useEffect } from 'react';
import { useHttpChatAgent } from './useHttpChatAgent';
import { IResponse } from '../../../hooks/useHttp';
import { useAppDispatch } from '../../../app/hooks';
import { incomingChatAgent, setChatAgentScrollPosition } from '../../../app/chatAgent/chatAgentSlice';

export const useFetchChatAgentHistory = (sessionid: string, limit: number, userName: string) => {
    const dispatch = useAppDispatch();
    const chatHistoryUrl = `/ChatHistory/?sessionid=${sessionid}&limit=${limit}`;
    const { response, error, loading, chatBaseUrl } = useHttpChatAgent({
        url: chatHistoryUrl,
        method: "get",
    });
    const retrieveData = (res: IResponse | undefined) => {
        const data = res?.data;
        const messages =
            data?.map((item) => {
                return {
                    roomId: item.room_id,
                    messageId: item.message_id,
                    message: item.message,
                    messageType: item.message_type,
                    messageTime: item.message_time,
                    minMessageTime: item.min_message_time,
                    messageFiles: item.message_files,
                    messageRead: item.message_read,
                    roomOwner: item.room_owner,
                    senderId: item.sender_id,
                    senderName: item.sender_name,
                    sessionId: item.session_id,
                    handledByAgent: item.handled_by_agent,
                    isSent: true,
                };
            }) ?? [];
        if (messages.length > 0) dispatch(incomingChatAgent({ messages: messages, userName: userName }));
    };

    useEffect(() => {
        dispatch(setChatAgentScrollPosition('bottom'));
        retrieveData(response);
    }, [response]);

    return { retrieveData, error, loading, chatBaseUrl, chatHistoryUrl };
};
